__turbopack_context__.v({
  "background": "TutorialBanner-module-scss-module__UAInsq__background",
  "container": "TutorialBanner-module-scss-module__UAInsq__container",
  "content": "TutorialBanner-module-scss-module__UAInsq__content",
  "cta": "TutorialBanner-module-scss-module__UAInsq__cta",
  "image": "TutorialBanner-module-scss-module__UAInsq__image",
  "overlay": "TutorialBanner-module-scss-module__UAInsq__overlay",
  "section": "TutorialBanner-module-scss-module__UAInsq__section",
  "subtitle": "TutorialBanner-module-scss-module__UAInsq__subtitle",
  "textWrapper": "TutorialBanner-module-scss-module__UAInsq__textWrapper",
  "title": "TutorialBanner-module-scss-module__UAInsq__title",
  "video": "TutorialBanner-module-scss-module__UAInsq__video",
});
